export default __webpack_public_path__ + "static/media/AR-Cards-dk-2-0.1.c8026069.jpg";